/** Round a major-unit amount to two decimal places (cents). */
export function roundToCents(amount: number): number {
  return Math.round(amount * 100) / 100;
}

/**
 * Week-over-week net change using the same rounding as displayed Net Position.
 *
 * Rounding the raw difference independently can be 1c off from
 * displayed(current) − displayed(previous) when GBP→EUR conversions leave
 * remainders (e.g. .626 vs .60).
 */
export function vsLastEntryDifference(currentNet: number, previousNet: number): number {
  return roundToCents(roundToCents(currentNet) - roundToCents(previousNet));
}
